// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__p3mtK","signatureButtonsRight":"ModalSign_signatureButtonsRight__zen7_"};